import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations de l'étudiant", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_8 = { class: "table table-bordered" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nom :")
], -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Prénoms :")
], -1)
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sexe :")
], -1)
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date de naissance :")
], -1)
const _hoisted_17 = { key: 4 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Lieu de naissance :")
], -1)
const _hoisted_19 = { key: 5 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Pays de résidence :")
], -1)
const _hoisted_21 = { key: 6 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email :")
], -1)
const _hoisted_23 = { key: 7 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Téléphone 1 :")
], -1)
const _hoisted_25 = { key: 8 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "WhatsApp :")
], -1)
const _hoisted_27 = { key: 9 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Adresse :")
], -1)
const _hoisted_29 = { key: 10 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Commune :")
], -1)
const _hoisted_31 = { key: 11 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Quartier :")
], -1)
const _hoisted_33 = { key: 12 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Niveau d'étude :")
], -1)
const _hoisted_35 = { key: 13 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Années d'expérience :")
], -1)
const _hoisted_37 = { key: 14 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Profession :")
], -1)
const _hoisted_39 = { key: 15 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Baptisé(e) :")
], -1)
const _hoisted_41 = { key: 16 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Paroisse :")
], -1)
const _hoisted_43 = { key: 17 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Groupe / Association :")
], -1)
const _hoisted_45 = { key: 18 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Situation matrimoniale :")
], -1)
const _hoisted_47 = { key: 19 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Formation en théologie déjà suivie :")
], -1)
const _hoisted_49 = { key: 20 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Voulez-vous suivre une formation en ligne ?")
], -1)
const _hoisted_51 = { key: 21 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Activités :")
], -1)
const _hoisted_53 = { key: 22 }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Horaires souhaités :")
], -1)
const _hoisted_55 = { class: "list-unstyled mb-0" }
const _hoisted_56 = { key: 23 }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Informations complémentaires :")
], -1)
const _hoisted_58 = { style: {"white-space":"pre-wrap"} }
const _hoisted_59 = { key: 24 }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Numéro Matricule :")
], -1)
const _hoisted_61 = { key: 25 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Filière :")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/liste-demande-inscriptions",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" Retour ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_ctx.demande?.nom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.prenom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.prenom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.sexe)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.sexe), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.dateNaissance)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.demande?.dateNaissance)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.lieuNaissance)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.lieuNaissance), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.nationalite)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.nationalite), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.email)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.email), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.telephone1)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.telephone1), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.whatsapp)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.whatsapp), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.adresse)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.adresse), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.commune)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.commune), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.quartier?.nom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.quartier?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.qualification?.libelle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.qualification?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.anneeExperience !== null && _ctx.demande?.anneeExperience !== undefined)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.anneeExperience) + " an(s)", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.profession)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.profession), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.baptise !== null && _ctx.demande?.baptise !== undefined)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.baptise), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.paroisse)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.paroisse), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.groupeAssociation)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.groupeAssociation), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.situationMatrimoniale)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.situationMatrimoniale), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.formationTheologie)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.formationTheologie), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.formationEnLigne)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.formationEnLigne), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.activites && _ctx.demande?.activites.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.activites.join(', ')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.horaires && _ctx.demande?.horaires.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("td", null, [
                      _createElementVNode("ul", _hoisted_55, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demande.horaires, (horaire, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            class: "mb-1"
                          }, " • " + _toDisplayString(horaire), 1))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.biographie)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.demande?.biographie), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.numeroMatricule)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.numeroMatricule), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.filiere?.libelle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.filiere?.libelle), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}